<template>
  <div class="table-responsive digital-contract-table">
    <table class="table table-striped table-bordered">
      <thead v-if="digitalContracts.length">
        <tr>
          <th>Chave do Contrato</th>
          <th>Curso</th>
          <th>Semetre</th>
          <th>Prioridade</th>
          <th>Informações Obrigatórias</th>
          <th>Status</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!digitalContracts.length">
          <td>
            Não há contratos digitais para exibir
          </td>
        </tr>
        <tr v-for="(digitalContrat, index) in digitalContracts" :key="index">
          <td>{{ digitalContrat.providerTemplateId }}</td>
          <td>{{ formatCourse(digitalContrat) }}</td>
          <td>{{ digitalContrat.semester }}</td>
          <td>{{ digitalContrat.priority }}</td>
          <td>{{ formatRequiredFields(digitalContrat.requiredFields) }}</td>
          <td>{{ formatStatus(digitalContrat) }}</td>
          <td>
            <button
              v-if="digitalContrat.enabled"
              class="btn btn-danger glyphicon glyphicon-trash"
              @click="selectDigitalContratForDisable(digitalContrat)"
            ></button>
          </td>
        </tr>
      </tbody>
    </table>
    <confirm-modal v-if="showConfirmModal" @close="showConfirmModal = false;" @confirm="disableDigitalContract()" />
  </div>
</template>
<style lang="scss" scoped>
  .digital-contract-table {
    max-height: 500px;
  }
</style>
<script>
import InstitutionDigitalContractsService from 'services/InstitutionDigitalContractsService';
import ConfirmModal from 'components/ConfirmModal';
import moment from 'moment';

export default {
  components: {
    ConfirmModal,
  },
  props: {
    digitalContracts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showConfirmModal: false,
      selectedDigitalContract: null,
    };
  },
  methods: {
    formatCourse(digitalContract) {
      if (digitalContract.course) {
        const { course } = digitalContract;
        return `${course.name} - ${course.kind} - ${course.shift} - ${course.level} - ${course.campus}`;
      }
      return '';
    },
    formatRequiredFields(requiredFields) {
      if (Array.isArray(requiredFields) && requiredFields.length) {
        return requiredFields;
      }
      return '';
    },
    formatDateTimeToString(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
    formatStatus(digitalContract) {
      if (digitalContract.enabled) {
        return 'Habilitado';
      }

      return `Desabiltado em ${this.formatDateTimeToString(digitalContract.enabledUntil)}`;
    },
    selectDigitalContratForDisable(digitalContract) {
      this.selectedDigitalContract = digitalContract;
      this.showConfirmModal = true;
    },
    disableDigitalContract() {
      this.$loader.show();
      InstitutionDigitalContractsService.disable(this.selectedDigitalContract.id)
        .then(() => {
          this.$emit('digital-contract-disabled', this.digitalContracts.indexOf(this.selectedDigitalContract));
          this.$alert.notifySuccess('Contrato digital desabilitado com sucesso.');
        })
        .catch(() => {
          this.$alert.notifyAlert('Erro ao desabilitar contrato digital, tente novamente mais tarde.');
        })
        .finally(() => {
          this.showConfirmModal = false;
          this.$loader.hide();
        });
    },
  },
};
</script>
